import Vue from "vue"
import VueRouter from 'vue-router'
import Index from '../page/Index'
import Home from '../page/Home'
import AdminList from '../page/system/AdminList'
import AddAdmin from '../page/system/AddAdmin'
import NewMsg from "@/page/NewMsg";
import ChildUser from "@/page/user/ChildUser";
import UpdateUser from "@/page/user/UpdateUser";
import IssueListByInvestId from "@/page/finance/IssueListByInvestId";
import BindBank from "@/page/user/BindBank";
import RiskPage from "@/page/user/RiskPage";
import BossLoginAdminSystem from "@/page/data/BossLoginAdminSystem";
import DataCount from "@/page/data/DataCount";

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        {path: '/index', name: 'Index',meta:{title:'【黑神话·悟空】管理系统（Z2）'}, component: Index},
        {path: '/home', name: 'Home',meta:{title:'【黑神话·悟空】管理系统(Z2) V1.0.2'}, component: Home},
        {path: '/admin/adminList', name: 'AdminList', component: AdminList},
        {path: '/admin/addAdmin', name: 'AddAdmin', component: AddAdmin},
        {path: '/newMsg', name: 'NewMsg',meta:{title:'详情'}, component: NewMsg},
        {path: '/childUser', name: 'ChildUser',meta:{title:'下级用户'}, component: ChildUser},
        {path: '/updateUser', name: 'UpdateUser',meta:{title:'编辑用户信息'}, component: UpdateUser},
        {path: '/issueListByInvestId', name: 'IssueListByInvestId',meta:{title:'发放明细'}, component: IssueListByInvestId},
        {path: '/bindBank', name: 'BindBank',meta:{title:'绑定银行卡'}, component: BindBank},
        {path: '/riskPage', name: 'RiskPage',meta:{title:'风险评估详情'}, component: RiskPage},
        {path: '/dataCount', name: 'DataCount',meta:{title:'【黑神话·悟空】数据系统（Z2）'}, component: DataCount},
    ]
})
router.beforeEach((to, from, next) => {//beforeEach是router的钩子函数，在进入路由前执行
    if (to.meta.title) {//判断是否有标题
        document.title = to.meta.title
    }
    next()//执行进入路由，如果不写就不会进入目标页
})
export default router;